import React from 'react';
import Footer from '../components/Footer';

// Import images
import pic1 from '../images/R (1).jpeg';
import pic2 from '../images/R (2).jpeg';
import pic3 from '../images/R (3).jpeg';
import pic4 from '../images/R (4).jpeg';
import pic5 from '../images/R (5).jpeg';
import pic6 from '../images/R (6).jpeg';
import pic7 from '../images/R (7).jpeg';
import pic8 from '../images/R (8).jpeg';
import pic9 from '../images/R (9).jpeg';
import pic10 from '../images/R (10).jpeg';
import pic11 from '../images/R (11).jpeg';
import pic12 from '../images/R (12).jpeg';
import pic13 from '../images/R (13).jpeg';
import pic14 from '../images/R (14).jpeg';
import pic15 from '../images/R (15).jpeg';
import pic16 from '../images/R (16).jpeg';
import pic17 from '../images/R (17).jpeg';
import pic18 from '../images/R (18).jpeg';
import pic19 from '../images/R (19).jpeg';
import pic20 from '../images/R (20).jpeg';
import pic21 from '../images/R (21).jpeg';
import pic22 from '../images/R (22).jpeg';
import pic23 from '../images/R (23).jpeg';
import pic24 from '../images/R (24).jpeg';

const Photos = () => {
    return (
        <div>

            <h2 className='text-center mt-4'>Gallery </h2>
            <div className="container my-4">
                <div className="row">
                    {/* Image 1 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic1} alt="Image 1" className="img-fluid" />
                    </div>
                    {/* Image 2 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic2} alt="Image 2" className="img-fluid" />
                    </div>
                    {/* Image 3 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic3} alt="Image 3" className="img-fluid" />
                    </div>
                    {/* Image 4 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic4} alt="Image 4" className="img-fluid" />
                    </div>
                    {/* Image 5 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic5} alt="Image 5" className="img-fluid" />
                    </div>
                    {/* Image 6 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic6} alt="Image 6" className="img-fluid" />
                    </div>
                    {/* Image 7 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic7} alt="Image 7" className="img-fluid" />
                    </div>
                    {/* Image 8 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic8} alt="Image 8" className="img-fluid" />
                    </div>
                    {/* Image 9 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic9} alt="Image 9" className="img-fluid" />
                    </div>
                    {/* Image 10 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic10} alt="Image 10" className="img-fluid" />
                    </div>
                    {/* Image 11 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic11} alt="Image 11" className="img-fluid" />
                    </div>
                    {/* Image 12 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic12} alt="Image 12" className="img-fluid" />
                    </div>
                    {/* Image 13 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic13} alt="Image 13" className="img-fluid" />
                    </div>
                    {/* Image 14 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic14} alt="Image 14" className="img-fluid" />
                    </div>
                    {/* Image 15 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic15} alt="Image 15" className="img-fluid" />
                    </div>
                    {/* Image 16 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic16} alt="Image 16" className="img-fluid" />
                    </div>
                    {/* Image 17 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic17} alt="Image 17" className="img-fluid" />
                    </div>
                    {/* Image 18 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic18} alt="Image 18" className="img-fluid" />
                    </div>
                    {/* Image 19 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic19} alt="Image 19" className="img-fluid" />
                    </div>
                    {/* Image 20 */}
                    <div className="col-md-3 mb-4">
                        <img src={pic20} alt="Image 20" className="img-fluid" />
                    </div>


                    <div className="col-md-3 mb-4">
                        <img src={pic21} alt="Image 20" className="img-fluid" />
                    </div>



                    <div className="col-md-3 mb-4">
                        <img src={pic22} alt="Image 20" className="img-fluid" />
                    </div>




                    <div className="col-md-3 mb-4">
                        <img src={pic23} alt="Image 20" className="img-fluid" />
                    </div>



                    <div className="col-md-3 mb-4">
                        <img src={pic24} alt="Image 20" className="img-fluid" />
                    </div>













                </div>

            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Photos;
